import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import Paging from "../../../components/Paging";
import { SCHEDULE_LIST, SCHEDULE_UPDATE_STATUS } from "../endpoints";
import CustomModal from "../CustomModal";
import { NavLink } from "react-router-dom";
import DropdownView from "./DropdownView";

class Lists extends Component {
	constructor(props) {
		super(props);

		this.state = {
			dataSiswa: [],
			dataParticipant: [],
			exam_cat_id: 0,
			pageCount: 0,
			currentPage: 0,
			isLoading: false,
			isModalShow: false,
			modalShow:false,
			examId:"",
	      	participant_id:""
		};

		this.toggle = this.toggle.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeStatus = this.handleChangeStatus.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
	    
	}

	toggle(tab) {
	    if (this.state.activeTab !== tab) {
	      this.setState({
	        activeTab: tab
	      });
	    }
	}

	toggleModal(e) {
		this.setState({
			modalShow: !this.state.modalShow,
			examId : e
		});
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		const newState = {
			[name]: value
		}
		this.setState(newState, () => this.loadData())
	}

	handleHapusButton(a) {
		this.setState({ isButtonLoading: true });

		const url = '/exam/delete-exam'

		let newState = {
			locale:"id",
			platform:"web",
			user_id:localStorage.SISMART_USER_ID,
			exam_id:a
		};

		axios({
			method: "post",
			url: url,
			data: qs.stringify(newState)
		})

		.then(response => {
			const result = response.data;

			if (result.status) {
				Alert.success(result.text);
				this.props.history.replace(
					"/exam/schedule"
				);
			} else {
				if (Array.isArray(result.text)) {
					result.text.map(item => {
						Alert.error(item);

						return true;
					});
				} else {
					Alert.error(result.text);
				}

				this.setState({ isButtonLoading: false });
			}
		})
		
		.catch(error => {
			console.log(error);
			this.setState({ isButtonLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});

		this.setState({ modalShow: false });
		window.location.reload()
	}

	handlePageClick(data) {
		let selected = data.selected; // zero based index

		this.setState({ currentPage: selected }, () => {
			this.loadData();
		});
	}

	handleChangeStatus(exam_id, exam_status) {
		axios
			.post(SCHEDULE_UPDATE_STATUS, qs.stringify({ exam_id, exam_status }))
			.then(response => {
				this.loadData();
			})
			.catch(error => {
				console.log(error);
				Alert.error("Gagal terhubung ke server!");
			});
	}

	loadData() {
		this.setState({ isLoading: true });

		const params = qs.stringify({
			page: this.state.currentPage + 1,
			locale:"id",
			platform:"web",
			exam_id:this.props.match.params.exam_id,
			participant_id:this.state.participant_id
		});

		axios({
			method: "post",
			url: "exam/participant-siswa?" + params
		})

		.then(response => {
			const result = response.data;
			
			if (result.status === true) {
				this.setState({
					dataSiswa: result.data.participant_siswa,
					pageCount: result.data.last_page,
					isLoading: false
				});
			} else {
				Alert.error(result.text);
				this.setState({ isLoading: false });
			}
		})
		.catch(error => {
			console.log(error);
			this.setState({ isLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});
	}

	loadDataParti(){
		this.setState({ isLoading: true });
		const params = qs.stringify({
			locale:"id",
			platform:"web",
			exam_id:this.props.match.params.exam_id
		});

		axios({
			method: "post",
			url: "exam/participant?" + params
		})
			.then(response => {
				const result = response.data;
				if (result.status === true) {
					const dataParticipant = result.data.participant.map(item => ({
						key: item.participant_id,
						value: item.kelas_nama
					}));

					this.setState({
						dataParticipant,
						isLoading: false
					});
				} else {
					Alert.error(result.text);
					this.setState({ isLoading: false });
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	componentDidMount() {
		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
        }
		this.loadData();
		this.loadDataParti();
	}

	render() {
		return (
			<div>
				<div className="card" style={{width:'500px'}}>
					<div className="card-block">
						<DropdownView
							handleChange={this.handleChange}
							stateName="participant_id"
							label="Pilih Kelas Peserta"
							disabled={this.props.mode === 'Edit' ? true : false}
							items={this.state.dataParticipant}
							value={this.state.participant_id}
						/>
					</div>
				</div>
				
				<div className="card">
					<div className="card-header">Data Jadwal Ujian & Soal</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : this.state.dataSiswa.length === 0 ? (
							"Data Kosong..."
						) : (
							<div>
								<div className="card">
									<table className="table table-striped table-bordered animated fadeIn">
									<thead>
										<tr>
											<th>Nama Soal </th>
											<th >Tanggal Ujian</th>
											<th width={200}>Status</th>
											<th width={200}>Soal</th>
										</tr>
									</thead>
									<tbody>
										{this.state.dataSiswa.map(items => {
											return (
												<tr key={items.entry_id}>
													
													<td>{items.user_nama}</td>
													<td>
														<small>
															<b>Dari:</b>
															<br /> {items.user_nama}
															<br />
															<b>Nis:</b>
															<br /> {items.siswa_nis}
															<br />
															<b>Score:</b>
															<br /> {items.score}
															<br />
															<b>Score Max:</b>
															<br /> {items.score_max}
															<br />
														</small>
													</td>
													<td>
														<button
															type="button"
															className={`btn btn-sm ${
																items.entry_status === "1"
																	? "btn-primary"
																	: "btn-danger"
															}`}
															
														>
															{items.exam_status === "1" ? "Aktif" : "Non Aktif"}
														</button>
													</td>
													<td>
														<NavLink
															to={`${this.props.match.url}/detail/${
																items.entry_id
															}`}
															className="btn btn-secondary btn-sm"
														>
															Koreksi
														</NavLink>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
								<Paging
									handlePageClick={this.handlePageClick.bind(this)}
									pageCount={this.state.pageCount}
									currentPage={this.state.currentPage}
								/>
								</div>
							</div>
						)}
					</div>
				</div>
				
			</div>
		);
	}
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Exam/Score/Lists.js